import type { Iso2700127701ControlModificacionPayload } from "../../types/control-modificaciones";
import {
  Iso2700127701Button,
  Iso2700127701InputField,
  Iso2700127701Modal,
  Iso2700127701TextareaField,
} from "../shared";

type Props = {
  open: boolean;
  title: string;
  value: Iso2700127701ControlModificacionPayload;
  submitting: boolean;
  error: string | null;
  onChange: (value: Iso2700127701ControlModificacionPayload) => void;
  onClose: () => void;
  onSubmit: () => void;
};

export function Iso2700127701ControlModificacionFormModal({
  open,
  title,
  value,
  submitting,
  error,
  onChange,
  onClose,
  onSubmit,
}: Props) {
  return (
    <Iso2700127701Modal
      open={open}
      title={title}
      description="Registra la fecha y el detalle del cambio realizado en el documento."
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Iso2700127701Button variant="secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </Iso2700127701Button>
          <Iso2700127701Button variant="primary" type="submit" disabled={submitting}>
            {submitting ? "Guardando..." : "Guardar modificación"}
          </Iso2700127701Button>
        </>
      }
    >
      <div className="iso27001-form-grid">
        <Iso2700127701InputField
          label="Fecha"
          value={value.fecha}
          required
          onChange={(event) => onChange({ ...value, fecha: event.target.value })}
        />
        <Iso2700127701TextareaField
          label="Modificaciones realizadas"
          value={value.modificaciones_realizadas}
          required
          rows={6}
          fullWidth
          onChange={(event) => onChange({ ...value, modificaciones_realizadas: event.target.value })}
        />
      </div>
      {error ? <div className="iso27001-form-error">{error}</div> : null}
    </Iso2700127701Modal>
  );
}
